import endOfTomorrow from 'date-fns/end_of_tomorrow';
import differenceInMinutes from 'date-fns/difference_in_minutes';
import addDays from 'date-fns/add_days';
import isBefore from 'date-fns/is_before';
import differenceInDays from 'date-fns/difference_in_days';
import differenceInHours from 'date-fns/difference_in_hours';
import addHours from 'date-fns/add_hours';
const MINUTES_IN_DAY = 60 * 24;
/**
 * Получаем понимание когда целевое действие наступит:
 * течении 24 часов - today
 * на следующий календарный день - tomorrow
 * через календарный день - dayAfterTomorrow
 * больше чем через 1 календарный день - laterOn
 */
export const getDatetimeActionType = datetimeAction => {
  if (differenceInMinutes(datetimeAction, new Date()) < MINUTES_IN_DAY) {
    return 'today';
  }
  if (isBefore(datetimeAction, endOfTomorrow())) {
    return 'tomorrow';
  }
  if (isBefore(datetimeAction, addDays(endOfTomorrow(), 1))) {
    return 'dayAfterTomorrow';
  }
  return 'laterOn';
};
/**
 * Подготавливаем дни, часыб минуты
 * @param datetimeAction - целевое действие
 */
export const getDayHourMinute = datetimeAction => {
  const days = differenceInDays(datetimeAction, new Date());
  const hours = differenceInHours(datetimeAction, addDays(new Date(), days));
  const minutes = differenceInMinutes(datetimeAction, addHours(addDays(new Date(), days), hours));
  return {
    days,
    hours,
    minutes
  };
};